import { Button } from "components/ui/Button";
import { DataTable } from "components/ui/DataTable";
import { PageHeader } from "components/ui/PageHeader";
import { SearchInput } from "components/ui/SearchInput";
import { drugsFileColumns } from "features/drugsFile/columns";
import { useDrugsFilePage } from "features/drugsFile/hooks/useDrugsFilePage";

import styles from "./DrugsFilePage.module.css";

export const DrugsFilePage = () => {
  const {
    drugs,
    isLoading,
    totalRecords,
    currentPage,
    rowsPerPage,
    searchParams,
    handlePageChange,
    handleRowsChange,
    handleSearchChange,
    clearSearch,
  } = useDrugsFilePage();

  const hasSearch = Object.values(searchParams).some(Boolean);

  return (
    <div className={styles.content}>
      <PageHeader title="Drugs File" />

      <DataTable
        columns={drugsFileColumns}
        data={drugs}
        isLoading={isLoading}
        emptyTitle="No drugs found"
        emptyText="No drugs match your search criteria."
        currentPage={currentPage}
        totalCount={totalRecords}
        rowsValue={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsChange={handleRowsChange}
        toolbarExtra={
          <>
            <SearchInput
              value={searchParams.tradeName}
              onChange={(value) => handleSearchChange("tradeName", value)}
              placeholder="Search by trade name"
              className={styles.drugsSearch}
            />
            <SearchInput
              value={searchParams.genericName}
              onChange={(value) => handleSearchChange("genericName", value)}
              placeholder="Search by generic name"
              className={styles.drugsSearchWide}
            />
            <SearchInput
              value={searchParams.manufacturer}
              onChange={(value) => handleSearchChange("manufacturer", value)}
              placeholder="Search by manufacturer"
              className={styles.drugsSearchWide}
            />
            {!!hasSearch && (
              <Button variant="outlineGray" size="small" onClick={clearSearch}>
                Clear
              </Button>
            )}
          </>
        }
      />
    </div>
  );
};
